import { Inject, Injectable, OnDestroy } from '@angular/core';
import { Observable, BehaviorSubject, of, Subscription, throwError } from 'rxjs';
import { map, catchError, switchMap, finalize, tap, take, shareReplay } from 'rxjs/operators';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ConfigStateService } from '@abp/ng.core';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class AuthService implements OnDestroy {
  // private fields
  private unsubscribe: Subscription[] = [];

  // public fields
  isLoading$: Observable<boolean>;
  isLoadingSubject: BehaviorSubject<boolean>;
  private refreshTimer: any;
  constructor(
    private http: HttpClient,
    private router: Router,
    private configService: ConfigStateService,
    // @Inject('Environment') private env: Environment
  ) {
    this.isLoadingSubject = new BehaviorSubject<boolean>(false);
    this.isLoading$ = this.isLoadingSubject.asObservable();
  }

  private refreshInProgress$: Observable<any | null> | null = null;
  private introspectInProgress$: Observable<any | null> | null = null;

  refreshToken(): Observable<any | null> {
    // console.warn('env',this.env )

    if (this.refreshInProgress$) {
      return this.refreshInProgress$;
    }

    this.refreshInProgress$ = this.refresh().pipe(
      tap((auth: any) => {
        this.handleLogin(auth);
      }),

      finalize(() => {
        this.refreshInProgress$ = null;
      }),
      shareReplay(1)
    );

    return this.refreshInProgress$;
  }
  introspectToken(token: string): Observable<any | null> {
    // console.warn('env',this.env )

    if (this.introspectInProgress$) {
      return this.introspectInProgress$;
    }

    this.introspectInProgress$ = this.introspect(token).pipe(
      tap((isActive: any) => {
        if(isActive){
         let expires_in= localStorage.getItem('expires_in');
        // this.reloadConfig()
        if (this.refreshTimer) clearTimeout(this.refreshTimer);
        const refreshDelay =new Date(expires_in).getTime() - Date.now()- ( 30 * 1000);
        this.refreshTimer = setTimeout(() => this.refreshToken().subscribe(), refreshDelay);
        }
        
      }),

      finalize(() => {
        this.introspectInProgress$ = null;
      }),
      shareReplay(1)
    );

    return this.introspectInProgress$;
  }
  private handleLogin(auth: any | null) {
    if (!auth) return;
    localStorage.setItem('access_token', auth.accessToken);
    localStorage.setItem(
      'expires_in',
      new Date(Date.now() + (Number(auth?.expiresIn) || 0) * 1000).toString()
    );
    // this.reloadConfig()
    if (this.refreshTimer) clearTimeout(this.refreshTimer);
    const refreshDelay = ((Number(auth?.expiresIn) || 0) - 30) * 1000;
    this.refreshTimer = setTimeout(() => this.refreshToken().subscribe(), refreshDelay);
  }
  public reloadConfig(): Observable<any> {

    return this.http
      .get(`${environment.apis.default.url}/api/abp/application-configuration`)
      .pipe(
      tap(configData => {
        this.configService.setState(configData);
      })
    );
  }
  ngOnDestroy() {
    this.unsubscribe.forEach(sb => sb.unsubscribe());
  }
  API_USERS_URL = `${environment.apis.auth.url}/user-service/api/v1/account`;

  refresh(): Observable<any> {
    return this.http.post<any>(`${this.API_USERS_URL}/refreshtoken`, {}, { withCredentials: true });
  }
  introspect(token: string): Observable<any> {
    return this.http.post<any>(
      `${this.API_USERS_URL}/instropect`,
      { token: token },
      { withCredentials: true }
    );
  }
  logout(accessToken: string): Observable<any> {
    if (this.refreshTimer) clearTimeout(this.refreshTimer);
    return this.http.post<string>(
      `${this.API_USERS_URL}/logout`,
      {
        accessToken:accessToken
      },
      { withCredentials: true }
    );
  }
  decodejwt(token: string): any {
    if (!token) {
      return null;
    }
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  }
}
